import { render, staticRenderFns } from "./decoration4.vue?vue&type=template&id=30065d5c&scoped=true"
import script from "./decoration4.vue?vue&type=script&lang=js"
export * from "./decoration4.vue?vue&type=script&lang=js"
import style0 from "./decoration4.vue?vue&type=style&index=0&id=30065d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30065d5c",
  null
  
)

export default component.exports